import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getRank } from "../../../http/api/MasterAPI";

const RankSelect = ({ onChange, value }) => {
  const [listRank, setListRank] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListRank() {
    try {
      const response = await getRank();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          rankId: element.varCd,
          rankName: element.varValue1,
        }))
        .filter(
          (x) => x.rankName && x.rankName.trim() !== ""
        );
      setListRank(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListRank();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listRank.map((item) => (
          <MenuItem
            key={item.rankId}
            value={item.rankId}
          >
            {item.rankName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default RankSelect;
